import type { RootState } from 'store';

export const selectActiveCommunityId = (state: RootState) => state.community.activeCommunityId;
export const selectShowCommunityCreationSuccessModal = (state: RootState) =>
  state.community.showCommunityCreationSuccessModal;
